import { AxiosResponse } from 'axios';
import client from './clientRetryable';
import IdDocType from '@/resources/enum/IdDocType';
import getAuthHeader from '@/util/getAuthHeader';
import MnDocType from '@/resources/enum/MnDocType';
import PhotoType from '@/resources/enum/PhotoType';
import store from '@/store';

export default {
  async fetchClientTypes(kycRequestID: number, isPC: boolean): Promise<AxiosResponse<ResponseClientTypes>> {
    const clientType: number = isPC ? 3 : 1;
    const request: RequestClientTypes = { clientType };
    const response: AxiosResponse<ResponseClientTypes> = await client.put<ResponseClientTypes>(
      `kyc_requests/${kycRequestID}/client_types`,
      request,
      {
        headers: getAuthHeader()
      }
    );

    if (response.status === 200) {
      // ClientTypes登録時に容貌真贋判定タイプ（パッシブ判定）を上書きする
      store.dispatch('auth/setKycOrgConfigFaceVerificationType', {
        faceVerificationType: response.data.faceVerificationType
      });
    }

    return response;
  },

  async fetchIdDocTypes(kycRequestID: number, request: RequestIdDocTypes): Promise<AxiosResponse<ResponseIdDocTypes>> {
    const response: AxiosResponse<ResponseIdDocTypes> = await client.put<ResponseIdDocTypes>(
      `kyc_requests/${kycRequestID}/id_doc_types`,
      request,
      {
        headers: getAuthHeader()
      }
    );
    return response;
  },

  async fetchMnDocTypes(kycRequestID: number, request: RequestMnDocTypes): Promise<AxiosResponse<void>> {
    const response: AxiosResponse<void> = await client.put<void>(
      `kyc_requests/${kycRequestID}/my_number_doc_types`,
      request,
      {
        headers: getAuthHeader()
      }
    );
    return response;
  },

  async fetchGpDocTypes(kycRequestID: number, request: RequestGpDocTypes): Promise<AxiosResponse<void>> {
    const response: AxiosResponse<void> = await client.put<void>(
      `kyc_requests/${kycRequestID}/general_doc_types`,
      request,
      {
        headers: getAuthHeader()
      }
    );
    return response;
  },

  async fetchOpDocTypes(kycRequestID: number, request: RequestOpDocTypes): Promise<AxiosResponse<void>> {
    const response: AxiosResponse<void> = await client.put<void>(
      `kyc_requests/${kycRequestID}/optional_doc_types`,
      request,
      {
        headers: getAuthHeader()
      }
    );
    return response;
  },

  async confirm(kycRequestID: number): Promise<AxiosResponse<void>> {
    const response: AxiosResponse<void> = await client.put<void>(`kyc_requests/${kycRequestID}/confirm`, null, {
      headers: getAuthHeader()
    });
    return response;
  }
};

export interface RequestClientTypes {
  clientType: number;
}

export interface RequestIdDocTypes {
  idDocType: IdDocType;
}

interface RequestMnDocTypes {
  myNumberDocType: MnDocType;
}

interface RequestGpDocTypes {
  generalDocType: string;
}

interface RequestOpDocTypes {
  seqNo: number;
  optionalDocType: string;
}

export interface ResponseClientTypes {
  faceVerificationType: 0 | 1;
}

export interface ResponseIdDocTypes {
  disabledAutoShootPhotoTypes: PhotoType[];
}
